import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const fromLoginOnlyGuard: CanActivateFn = () => {
  const router = inject(Router);

  const state = history.state;

  if (state?.['fromLogin']) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
